import { BASE_URL } from '../configs/config';

export const subscribeToTopic = async (topic: string, deviceToken: string[]) => {
  try {
    const res = await fetch(`${BASE_URL}subscribeToTopic/${topic}`, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        deviceToken,
      }),
    });
    return res;
  } catch (error) {}
};

export const unsubscribeFromTopic = async (topic: string, deviceToken: string[]) => {
  try {
    const res = await fetch(`${BASE_URL}unsubscribeToTopic/${topic}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        deviceToken,
      }),
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const sendNotifications = async (
  userid: string,
  payload: {
    id: string;
    status: string;
  }
) => {
  try {
    const res = await fetch(`${BASE_URL}sendNotifications/${userid}`, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...payload,
      }),
    });
    return res;
  } catch (error) {}
};
